import MFA from "@irati/auth/utils/mfa"
import {AxiosError} from "axios"
import isMFARequired, {isGraphMFARequired} from "./isMFARequired"
import {APIResponse} from "../../index"

export {isMFARequired, isGraphMFARequired}

let inFlight: Promise<any> | null = null

export default function mfaTokenAndReplay(err: AxiosError | APIResponse): Promise<any> {
  if (!inFlight) {
    inFlight = showPopup()
  }

  return inFlight
    .then(() => {
      inFlight = null
    })
    .catch(() => {
      inFlight = null
      throw err
    })
}

function showPopup(): Promise<any> {
  return new Promise((resolve, reject) => {
    MFA.start(resolve, reject)
  })
}
